<template>
  <div>
    {{ this.XrayChangVn }}
    <div
      v-if="
        XrayReportDataObj != '[]' &&
          XrayReportDataObj != '' &&
          XrayReportDataObj != null
      "
    >
      <b-alert show variant="dark" class="margin-bottom font12px">
        <h6 class="font-color-white1">
          Xray Report {{ this.$store.get("systems@PAC_ONLINE") }}
        </h6>
        <b-row class="margin-bottom">
          <b-col
            lg="6"
            v-for="(item, index) in XrayReportDataObj"
            v-bind:key="item.id"
            class="margin-bottom"
          >
            <b-alert variant="success" show>
              <div>
                <!-- <a
                  :href="
                    PacUrl +
                      '&patient_id=' +
                      item.datas.hn +
                      '&accession_number=' +
                      item.datas.xn
                  "
                  class="alert-link"
                  :target="item.datas.xn"
                > -->
                <strong
                  @click="XrayOpen(item.datas.hn, item.datas.xn)"
                  class="cursor-pointer"
                  >{{ index + 1 }}.
                  {{
                    item.datas.xray_items_name +
                      " | Read : " +
                      item.datas.confirm
                  }}</strong
                >
                <!-- </a> -->
              </div>
              <div>
                Request Date :
                {{
                  thaiDatetimeFc.ThaiDateTime(
                    item.datas.request_date + " " + item.datas.request_time
                  )
                }}
              </div>
              <div
                v-if="
                  item.datas.report_time != '' &&
                    item.datas.report_time != null &&
                    item.datas.report_time != '00:00:00'
                "
              >
                Report Date :
                {{
                  thaiDatetimeFc.ThaiDateTime(
                    item.datas.report_date + " " + item.datas.report_time
                  )
                }}
              </div>
              <div class="log-style">
                D.Request : {{ item.datas.request_doctor_name }}
              </div>
              <div class="log-style" v-if="item.datas.report_doctor_name">
                D.Report : {{ item.datas.report_doctor_name }}
              </div>
            </b-alert>
            <div v-if="item.datas.report_text">
              <b-alert show>
                <div class="pj_clearfix">
                  <h6>
                    <b-badge
                      href="#"
                      variant="success"
                      class="font-color-dark2"
                      v-b-toggle="'collapse-xray-report' + (index + 1)"
                      >Report : {{ item.datas.xray_items_name }}</b-badge
                    >
                  </h6>
                </div>
                <b-collapse
                  :id="'collapse-xray-report' + (index + 1)"
                  class="mt-2"
                >
                  <div v-html="TextToHtml(item.datas.report_text)"></div>
                </b-collapse>
              </b-alert>
            </div>
          </b-col>
        </b-row>
      </b-alert>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import PatientXrayHead from "@/models/patientEMRs/PatientXrayHead";
import PatientWebbaseUrl from "@/models/patientEMRs/PatientWebbaseUrl";

import PatientXrayReport from "@/models/patientEMRs/PatientXrayReport";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";

Vue.use(feather, "v-icon");

@Component({
  data() {
    return {
      vnStart: "",
      XrayHeadData: null,
      XrayReportData: null,
      thaiDatetimeFc: null,
      ptHN: "",
      ptVN: "",
      DataCh: "",
      XrayReportDataObj: null,
      PacUrl: ""
    };
  },
  props: ["MyVn", "MyHn"],
  component: {
    PatientXrayHead,
    PatientXrayReport,
    thaiDatetime,
    PatientWebbaseUrl
  },
  created() {
    this.XrayChangVn, (this.thaiDatetimeFc = thaiDatetime.methods);
    this.pjFunctionsFc = pjFunctions.methods;
  },
  watch: {
    ptHN: function() {
      // this.SetXrayReport(this.ptVN,this.ptHN)
    },
    ptVN: function() {
      this.SetXrayReport(this.ptVN, this.ptHN);
      this.GetPacUrl();
    },
    DataCh: function() {
      this.GetXrayReport(this.ptVN, this.ptHN);
    }
  },
  computed: {
    XrayChangVn: function() {
      this.ptHN = this.MyHn;
      this.ptVN = this.MyVn;
    }
  },
  methods: {
    SetXrayReport(vn, hn) {
      this.DataCh = "StartXrayReportData" + vn;

      this.DataCh = "startXrayReportData" + vn;

      if (
        PatientXrayHead.query()
          .where("hn", hn)
          .where("department", "OPD")
          .get()[0]
      ) {
        let XrayHeadObj = PatientXrayHead.query()
          .where(record => record.datas.hn == hn)
          .where(record => record.datas.vn == vn)
          .where("department", "OPD")
          .orderBy(record => record.datas.xn)
          .get();

        for (let i = 0; i < XrayHeadObj.length; i++) {
          let XrayReportObj = this;
          this.axios
            .post(this.$store.get("systems@UrlApi") + "XrayReportData", {
              CompanyId: this.$store.get("systems@CompanyId"),
              ApiKey: this.$store.get("systems@ApiKey"),
              hn: XrayHeadObj[i].hn,
              vn: XrayHeadObj[i].vn,
              lab_order_number: XrayHeadObj[i].xn
            })
            .then(function(response) {
              XrayReportObj.output = response.data;
              if (XrayReportObj.output.status === true) {
                PatientXrayReport.delete({
                  where(record) {
                    return record.vn == vn;
                  }
                });

                let data = [];
                for (var val of XrayReportObj.output.result) {
                  data.push({
                    id: val.xn,
                    xn: val.xn,
                    hn: val.hn,
                    vn: val.vn,
                    an: val.an,
                    datas: val
                  });
                }

                PatientXrayReport.insertOrUpdate({
                  data
                });
              } else {
                if (XrayReportObj.output.ErrorMessage === "Data Not Found") {
                  PatientXrayReport.delete({
                    where(record) {
                      return record.vn == vn;
                    }
                  });
                }
              }
            })
            .catch(function(error) {
              XrayReportObj.output = error;
              console.log("XrayReportData : " + XrayReportObj.output);
            })
            .finally(function() {
              XrayReportObj.DataCh = "XrayReportData" + vn;
            });
        }

        this.vnStart = vn;
      } else {
        return null;
      }
    },
    GetXrayReport(vn, hn) {
      let GetXrayReportObj = PatientXrayReport.query()
        .where(record => record.datas.hn == hn)
        .where(record => record.datas.vn == vn)
        .get();

      this.XrayReportDataObj = GetXrayReportObj;
    },
    GetPacUrl() {
      let PacUrlObj = "";

      if (this.$store.get("systems@PAC_ONLINE") === "Y") {
        PacUrlObj = PatientWebbaseUrl.query()
          .where(record => record.web_name == "PAC_INTERNET")
          .get();
      } else {
        PacUrlObj = PatientWebbaseUrl.query()
          .where(record => record.web_name == "PAC")
          .get();
      }

      if (PacUrlObj.length > 0) {
        this.PacUrl = PacUrlObj[0].web_host;
      }

      // console.log('ddddddddd', PacUrlObj)
    },
    TextToHtml(txt) {
      if (txt != null && txt != "") {
        String.prototype.replaceAll = function(search, replacement) {
          var target = this;
          return target.split(search).join(replacement);
        };
        let PgNote = txt;
        PgNote = PgNote.replaceAll("\n", "<br>");

        return PgNote;
      } else {
        return "";
      }
    },
    XrayOpen(hn, xn) {
      let param = {
        hn: hn,
        xn: xn
      };

      if (
        hn != "" &&
        this.PacUrl != "" &&
        this.PacUrl != null &&
        this.$store.get("systems@XRAY_REPORT_OUT_LINK") == "Y"
      ) {
        window.open(this.PacUrl + "&accession_number=" + xn, "_blank");
        /*
        this.pjFunctionsFc.OpenWindowWithPost(
          this.PacUrl + "&patient_id=" + hn + "&accession_number=" + xn,
          "width=1200,height=600,left=100,top=10,resizable=yes,scrollbars=yes",
          "NewFile",
          hn + xn,
          param
        );
        */
      }
    }
  }
})
export default class EmrXrayOPD extends Vue {}
</script>

<style lang="scss">
</style>

